import main from "./main";

export default {
  install(Vue) {
    Vue.addRoutes({
      path: "/nfactor/email-auth",
      component: main,
    });
  },
};